import type { MetaEmbeddedSignupCompletePayload } from '../../services/api'
import { META_EMBEDDED_SIGNUP_SUCCESS_EVENTS } from './constants'
import type {
  FlowStatus,
  MetaEmbeddedSignupAssetData,
  MetaEmbeddedSignupMessage,
  SdkStatus,
  SignupSession,
} from './types'

export function getMetaEnv() {
  const env = (import.meta as any).env || {}
  return {
    appId: String(env.VITE_META_APP_ID || ''),
    configurationId: String(env.VITE_META_EMBEDDED_SIGNUP_CONFIG_ID || ''),
    graphApiVersion: String(env.VITE_META_GRAPH_API_VERSION || 'v24.0'),
  }
}

export function isFacebookOrigin(origin: string) {
  try {
    const { hostname } = new URL(origin)
    return hostname === 'facebook.com' || hostname.endsWith('.facebook.com')
  } catch {
    return false
  }
}

export function parseMetaMessageData(value: unknown): unknown {
  if (typeof value === 'string') {
    return JSON.parse(value)
  }
  return value
}

export function isEmbeddedSignupMessage(value: unknown): value is MetaEmbeddedSignupMessage {
  return (
    typeof value === 'object' &&
    value !== null &&
    'type' in value &&
    (value as { type?: unknown }).type === 'WA_EMBEDDED_SIGNUP'
  )
}

export function isSuccessEvent(event: string) {
  return META_EMBEDDED_SIGNUP_SUCCESS_EVENTS.has(event) || event.startsWith('FINISH')
}

export function hasMetaError(data?: MetaEmbeddedSignupAssetData) {
  return Boolean(data?.error_code || data?.error_message || data?.session_id)
}

export function buildCompletionPayload(
  code: string,
  session: SignupSession,
  smbId?: string
): MetaEmbeddedSignupCompletePayload {
  return {
    code,
    event: session.event,
    waba_id: session.data.waba_id,
    phone_number_id: session.data.phone_number_id,
    business_id: session.data.business_id,
    smb_id: smbId,
  }
}

export function getButtonLabel(flowStatus: FlowStatus, sdkStatus: SdkStatus) {
  if (flowStatus === 'submitting') return 'Completing...'
  if (flowStatus === 'waiting') return 'Waiting for Meta...'
  if (flowStatus === 'opening') return 'In Progress...'
  if (sdkStatus === 'loading') return 'Loading Meta...'
  return 'Connect WhatsApp'
}

export function extractApiErrorMessage(error: unknown): string | undefined {
  const axiosError = error as { response?: { data?: { error?: { message?: string } } } }
  return axiosError.response?.data?.error?.message
}
